/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Oci_NumberInputs */

const en_cargo_oci_number = /** @type {(inputs: Cargo_Oci_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCI Number`)
};

const es_cargo_oci_number = /** @type {(inputs: Cargo_Oci_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero OCI`)
};

/**
* | output |
* | --- |
* | "OCI Number" |
*
* @param {Cargo_Oci_NumberInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_oci_number = /** @type {((inputs?: Cargo_Oci_NumberInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Oci_NumberInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_oci_number(inputs)
	return es_cargo_oci_number(inputs)
});